import FlowioMultiSelect from "./FlowioMultiSelect";

export default FlowioMultiSelect;
export type { FlowioMultiSelectProps } from "./FlowioMultiSelect";
